import { useGetDrawerPermissionLazyQuery } from '@contract-root/admin-react/src/generated/graphql';
import ClientApp from '@ifca-root/react-component/src/assets/contractIcons/app/client.svg';
import SubconApp from '@ifca-root/react-component/src/assets/contractIcons/app/subcontractor.svg';
import SupplierApp from '@ifca-root/react-component/src/assets/contractIcons/app/suppliers.svg';
import CompanySetup from '@ifca-root/react-component/src/assets/icons/CompanySetup/company-profile.svg';
import ClientProfile from '@ifca-root/react-component/src/assets/icons/Sidemenu/client.svg';
import MyProfile from '@ifca-root/react-component/src/assets/icons/Sidemenu/my-profile.svg';
import SubconProfile from '@ifca-root/react-component/src/assets/icons/Sidemenu/subcon.svg';
import SupplierProfile from '@ifca-root/react-component/src/assets/icons/Sidemenu/supplier.svg';
import AccessSecurity from '@ifca-root/react-component/src/assets/icons/SystemAdmin/access-sec.svg';
import CommonSetting from '@ifca-root/react-component/src/assets/icons/SystemAdmin/common-setting.svg';
import GeneralSetting from '@ifca-root/react-component/src/assets/icons/SystemAdmin/general-setting.svg';
import CompanyActive from '@ifca-root/react-component/src/assets/icons/company-w.svg';
import GeneralSettingActive from '@ifca-root/react-component/src/assets/icons/general-setting-w.svg';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { smallTitle } from '@ifca-root/react-component/src/helpers/Global/ContractGlobalVar';
import { CX_VERSION } from '@ifca-root/react-component/src/helpers/Global/ContractVersion';
import { navigateReactUrl } from '@ifca-root/react-component/src/utils/hooks/navigateReactUrl';
import {
  Avatar,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
} from '@material-ui/core';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { ExpandMore, KeyboardArrowRight } from '@material-ui/icons';
import GroupBI from 'assets/icons/HomeApp/group-biz-insight.svg';
import SiteMgmt from 'assets/icons/HomeApp/site-mgmt-icon.svg';
import SystemAdmin from 'assets/icons/HomeApp/system-admin.svg';
import AIAssistantIcon from 'assets/icons/SideMenu/ai-icon.svg';
import FinancialReport from 'assets/icons/SideMenu/financial-report.svg';
import Home from 'assets/icons/SideMenu/home.svg';
import ContractSetup from 'assets/icons/SideMenu/project-setup.svg';
import Profile from 'assets/icons/SideMenu/user-profile.svg';
import HomeActive from 'assets/icons/home-w.svg';
import Logout from 'assets/icons/logout.svg';
import { externalHomeRoutes } from 'containers/HomeModule/Function/ExternalHomeRoutes';
import {
  ContPermission,
  ContractXModule,
  useLoggedInUserProfileLazyQuery,
  useUpdateUserActivityModuleMutation,
} from 'generated/graphql';
import { useBroadcastChannel } from 'helpers/Hooks/useBroadcastChannel';
import React, { MouseEvent, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { NavLink } from 'react-router-dom';

export const drawerWidth = 240;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawer: {
      [theme.breakpoints.up('sm')]: {
        width: drawerWidth,
        flexShrink: 0,
      },
    },
    drawerPaper: {
      width: drawerWidth,
      [theme.breakpoints.up('sm')]: {
        top: 64,
        height: 'calc(100% - 64px)',
      },
      zIndex: 100,
    },
    content: { flexGrow: 1, padding: theme.spacing(3) },
    activeListItem: {
      borderLeft: '4px solid red',
      boxShadow: '0 3px 2px -3px gray',
      backgroundColor: 'blue',
      '& $listItemText': {
        color: 'white',
        marginTop: 0,
        marginBottom: 0,
        fontWeight: 500,
      },
      '& $listItemIcon': {
        color: 'white',
        marginLeft: '-4px',
        minWidth: '36px',
      },
    },
    listItemText: {
      fontSize: '1rem',
      fontWeight: 400,
      color: 'black',
      marginTop: 0,
      marginBottom: 0,
    },
  }),
);

interface Props {
  window?: () => Window;
  open?: boolean;
  variant?: any;
  onCloseDrawer?: any;
}
interface NavigationProps {
  name: string;
  path: string;
  icon: any;
  iconSelected: any;
  reroute: boolean;
  reroutePath: string;
  deployed: boolean;
  permission: any;
}

export default function LayoutDrawer(props: Props) {
  const { window, open, onCloseDrawer, variant, ...rest } = props;
  const classes = useStyles();
  const container =
    window !== undefined ? () => window().document.body : undefined;
  let history = useHistory();
  const { signOut } = useBroadcastChannel();
  const mode: any = history?.location?.pathname;

  let isHomeMenu: boolean = false,
    isHomeGroup: boolean = false;

  const isMainHomeMenuDrawer =
    mode === '/' ||
    mode === '/home' ||
    mode === '/group-bi' ||
    mode === '/access-security' ||
    mode === '/common-settings' ||
    mode === '/system-settings' ||
    mode === '/company-setup' ||
    mode === '/ai-assistant';

  if (mode === '/alternate') isHomeMenu = true;

  if (isMainHomeMenuDrawer) isHomeGroup = true;

  const [
    fetchUserInfo,
    { loading, data: { loggedInUserProfile } = { loggedInUserProfile: null } },
  ] = useLoggedInUserProfileLazyQuery({ fetchPolicy: 'network-only' });

  const [
    fetchDrawer,
    {
      loading: drawerLoading,
      data: {
        getDrawerPermission: {
          groupBI,
          accessSecurity,
          commonSetting,
          companySetup,
          generalSetting,
          contractSetting,
          systemSetting,
        },
      } = {
        getDrawerPermission: {
          groupBI: false,
          accessSecurity: false,
          commonSetting: false,
          companySetup: false,
          generalSetting: false,
          contractSetting: false,
          systemSetting: false,
        },
      },
    },
  ] = useGetDrawerPermissionLazyQuery({
    fetchPolicy: 'network-only',
  });

  const [
    updateModule,
    { loading: updateModuleLoading },
  ] = useUpdateUserActivityModuleMutation({
    onError: ({ message }) => {},
  });

  const pageMode = reconsRoute(mode);

  let genSettings = 'contract';

  if (
    pageMode == 'access-security' ||
    pageMode === 'company-setup' ||
    pageMode === 'common-settings'
  ) {
    genSettings = 'contract';
  } else genSettings = pageMode;

  let isPathForContSett = [
    '/contract',
    '/client-account',
    '/subcontract',
    '/subcontractor-account',
    '/supplier',
    '/client-contract',
    '/pob-client-contract',
    '/project-costing',
    '/profit-recognition',
  ];

  const checkPathConSet = mode => {
    let k = isPathForContSett.filter(k => mode?.includes(k));
    return k.length > 0;
  };

  const isSysAdmin = ['/system-admin'];

  const checkSysAdmin = mode => {
    let k = isSysAdmin.filter(k => mode?.includes(k));
    return k.length > 0;
  };

  // LOCALHOST NAVIGATION
  const {
    siteReactUrl,
    clientReactUrl,
    subcontractorReactUrl,
    supplierReactUrl,
  } = externalHomeRoutes();

  const defaultHomeMenu = [
    {
      name: 'Home Page',
      path: '/home',
      icon: Home,
      module: ContractXModule.Home,
      iconSelected: HomeActive,
      reroute: false,
      reroutePath: '',
      deployed: true,
      permission: true,
    },
  ];

  const defaultLogoutMenu = [
    {
      name: 'Logout',
      path: '/logout',
      icon: Logout,
      module: ContractXModule.Cx,
      iconSelected: Logout,
      reroute: false,
      reroutePath: '',
      deployed: true,
      permission: true,
    },
  ];

  const defaultMyProfileMenu = [
    {
      name: smallTitle.MY_PROFILE,
      path: '/profile',
      icon: MyProfile,
      module: ContractXModule.MyProfile,
      iconSelected: MyProfile,
      reroute: false,
      reroutePath: '',
      deployed: true,
      permission: true,
    },
  ];

  const defaultGenSettingsMenu = [
    {
      name: smallTitle.GENERAL_SETTINGS,
      path: `/${genSettings}/general-settings`,
      icon: GeneralSetting,
      module: ContractXModule.GeneralSettings,
      iconSelected: GeneralSettingActive,
      reroute: false,
      reroutePath: '',
      deployed: true,
      permission: generalSetting,
    },
  ];

  const defaultConSettingsMenu = [
    {
      name:
        pageMode === 'profit-recognition'
          ? smallTitle.CONTRACT_SETTINGS
          : smallTitle.CONTRACT_POLICY,
      path: `/${pageMode ?? 'contract'}/contract-settings`,
      icon: ContractSetup,
      module: ContractXModule.ContractSettings,
      iconSelected: ContractSetup,
      reroute: false,
      reroutePath: '',
      deployed: true,
      permission: contractSetting,
    },
  ];

  const defaultGroupBIMenu = [
    {
      name: smallTitle.GROUP_BI,
      path: '/group-bi',
      icon: GroupBI,
      module: ContractXModule.GroupBusinessInsights,
      iconSelected: GroupBI,
      reroute: false,
      reroutePath: '',
      deployed: true,
      permission: groupBI,
    },
  ];

  const defaultAIAssistantMenu = [
    {
      name: 'AI Assistant',
      path: `/ai-assistant`,
      icon: AIAssistantIcon,
      module: null,
      iconSelected: AIAssistantIcon,
      reroute: false,
      reroutePath: '',
      deployed:
        process.env.REACT_APP_LOCAL_DB === 'prod' ||
        process.env.REACT_APP_LOCAL_DB === 'prod2'
          ? false
          : true,
      permission: groupBI,
    },
  ];

  const defaultAccessSecurity = [
    {
      name: smallTitle.ACCESS_SECURITY,
      path: `/access-security`,
      icon: AccessSecurity,
      module: ContractXModule.AccessSecurity,
      iconSelected: AccessSecurity,
      reroute: false,
      reroutePath: '',
      deployed: true,
      permission: accessSecurity,
    },
  ];

  const defaultCommonSettings = [
    {
      name: smallTitle.COMMON_SETTINGS,
      path: `/common-settings`,
      icon: CommonSetting,
      module: ContractXModule.CommonSettings,
      iconSelected: CommonSetting,
      reroute: false,
      reroutePath: '',
      deployed: true,
      permission: commonSetting,
    },
  ];

  const defaultSystemSettingsMenu = [
    {
      name: smallTitle.SYSTEM_SETTINGS,
      path: `/system-settings`,
      icon: CommonSetting,
      module: ContractXModule.SystemSettings,
      iconSelected: CommonSetting,
      reroute: false,
      reroutePath: '',
      deployed: true,
      permission: systemSetting,
    },
  ];

  const defaultCompanySetupMenu = [
    {
      name: smallTitle.COMPANY_SETUP,
      path: `/company-setup`,
      icon: CompanySetup,
      module: ContractXModule.CompanySetup,
      iconSelected: CompanyActive,
      reroute: false,
      reroutePath: '',
      deployed: true,
      permission: companySetup,
    },
  ];

  const defaultGeneralSettingsMenu = [
    {
      name: smallTitle.GENERAL_SETTINGS,
      path: `/contract/general-settings`,
      icon: GeneralSetting,
      module: ContractXModule.GeneralSettings,
      iconSelected: GeneralSetting,
      reroute: false,
      reroutePath: '',
      deployed: true,
      permission: generalSetting,
    },
  ];

  const defaultFinancialReportsMenu = [
    {
      name: smallTitle.FINANCIAL_REPORT,
      path: `/financial-reporting`,
      icon: FinancialReport,
      module: ContractXModule.FinancialReports,
      iconSelected: FinancialReport,
      reroute: false,
      reroutePath: '',
      deployed: true,
      permission: generalSetting,
    },
  ];

  const defaultSystemAdminMenu = [
    {
      name: smallTitle.SYSTEM_ADMIN,
      path: `/system-admin`,
      icon: SystemAdmin,
      module: ContractXModule.SystemAdmin,
      iconSelected: SystemAdmin,
      reroute: false,
      reroutePath: '',
      deployed: true,
      permission: ContPermission.SystemAdminIcon,
    },
  ];
  const defaultAssociateProfileMenu = [
    {
      name: smallTitle.CLIENT_APP,
      path: `/client-profile`,
      icon: ClientProfile,
      module: ContractXModule.ClientProfile,
      iconSelected: ClientProfile,
      reroute: false,
      reroutePath: '',
      deployed: true,
      permission: ContPermission.GeneralSettingsIcon,
    },
    {
      name: smallTitle.SUBCON_APP,
      path: `/subcontractor-profile`,
      icon: SubconProfile,
      module: ContractXModule.SubContractorProfile,
      iconSelected: SubconProfile,
      reroute: false,
      reroutePath: '',
      deployed: true,
      permission: ContPermission.GeneralSettingsIcon,
    },
    {
      name: smallTitle.SUPPLIER_APP,
      path: `/supplier-profile`,
      icon: SupplierProfile,
      module: ContractXModule.SupplierProfile,
      iconSelected: SupplierProfile,
      reroute: false,
      reroutePath: '',
      deployed: true,
      permission: ContPermission.GeneralSettingsIcon,
    },
  ];

  const navigations: any = isHomeMenu
    ? [
        ...defaultHomeMenu,
        ...defaultGroupBIMenu,
        ...defaultAccessSecurity,
        ...defaultCommonSettings,
        ...defaultCompanySetupMenu,
        {
          name: smallTitle.SITE_MANAGEMENT,
          path: `/login`,
          icon: SiteMgmt,
          module: ContractXModule.SiteManagement,
          iconSelected: SiteMgmt,
          reroute: true,
          reroutePath: siteReactUrl,
          deployed: true,
          permission: true,
        },
        {
          name: smallTitle.CLIENT_APP,
          path: '/login',
          icon: ClientApp,
          module: ContractXModule.ClientApp,
          iconSelected: ClientApp,
          reroute: true,
          reroutePath: clientReactUrl,
          deployed:
            process.env.REACT_APP_LOCAL_DB === 'prod' ||
            process.env.REACT_APP_LOCAL_DB === 'prod2'
              ? false
              : true,
          permission: true,
        },
        {
          name: smallTitle.SUBCON_APP,
          path: '/login',
          icon: SubconApp,
          module: ContractXModule.SubcontractorApp,
          iconSelected: SubconApp,
          reroute: true,
          reroutePath: subcontractorReactUrl,
          deployed:
            process.env.REACT_APP_LOCAL_DB === 'prod' ||
            process.env.REACT_APP_LOCAL_DB === 'prod2'
              ? false
              : true,
          permission: true,
        },
        {
          name: smallTitle.SUPPLIER_APP,
          path: '/login',
          icon: SupplierApp,
          module: ContractXModule.SupplierApp,
          iconSelected: SupplierApp,
          reroute: true,
          reroutePath: supplierReactUrl,
          deployed:
            process.env.REACT_APP_LOCAL_DB === 'prod' ||
            process.env.REACT_APP_LOCAL_DB === 'prod2'
              ? false
              : true,
          permission: true,
        },
        ...defaultMyProfileMenu,
        ...defaultSystemSettingsMenu,
        ...defaultAIAssistantMenu,
        ...defaultLogoutMenu,
      ]
    : isHomeGroup
    ? [
        ...defaultHomeMenu,
        ...defaultGroupBIMenu,
        ...defaultFinancialReportsMenu,
        ...defaultCompanySetupMenu,
        ...defaultAccessSecurity,
        ...defaultCommonSettings,
        ...defaultSystemSettingsMenu,
        ...defaultGeneralSettingsMenu,
        ...defaultConSettingsMenu,
        ...defaultAIAssistantMenu,
        ...defaultLogoutMenu,
      ]
    : checkPathConSet(mode) && !checkSysAdmin(mode)
    ? [
        ...defaultHomeMenu,
        ...defaultGenSettingsMenu,
        ...defaultConSettingsMenu,
        ...defaultLogoutMenu,
      ]
    : checkSysAdmin(mode) || mode === '/profile'
    ? [...defaultHomeMenu, ...defaultLogoutMenu]
    : [...defaultHomeMenu, ...defaultGenSettingsMenu, ...defaultLogoutMenu];

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const user = JSON.parse(localStorage.getItem('loggedInUser'));

  const handleProfileClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRedirectProfile = () => {
    if (!!onCloseDrawer) onCloseDrawer();
    setAnchorEl(null);
    history.push('/profile');
  };

  useEffect(() => {
    if (!user?.avatar || user === null) fetchUserInfo();
  }, [user?.ID]);

  useEffect(() => {
    if (mode === '/home' || mode === '/' || pageMode)
      fetchDrawer({ variables: { pageMode: pageMode } });
  }, [mode]);

  const drawer = (
    <div className="route-container">
      <List disablePadding>
        {navigations?.map((v, index) => {
          if (!!v?.deployed && v?.permission)
            return (
              <ListItem
                button
                key={index}
                dense
                activeClassName={'active'}
                divider
                component={NavLink}
                to={{ pathname: v?.reroute ? '' : v?.path }}
                onClick={() => {
                  updateModule({
                    variables: { lastAccessedModule: v?.module },
                  });
                  if (v?.reroute) navigateReactUrl(v?.reroutePath, v?.path);
                  if (v?.path === `/${pageMode}/contract-settings`)
                    localStorage.setItem('backPath', mode);
                  else localStorage.removeItem('backPath');

                  if (!!onCloseDrawer) onCloseDrawer();

                  if (v?.name === 'Logout') {
                    signOut(user?.ID);
                    // sessionStorage.clear();
                    // sessionStorage.removeItem('accessToken');
                  }
                  localStorage.removeItem('searchDropdown');
                  localStorage.removeItem('searchFilter');
                  localStorage.removeItem('firstRenderLocal');
                }}
              >
                <ListItemIcon>
                  <img className="icon-svg" src={v?.icon} alt="drawer-icon" />
                </ListItemIcon>
                <ListItemText primary={v?.name} />
              </ListItem>
            );
        })}
        {/* Version number */}
        <ListItem style={{ justifyContent: 'center' }}>
          <ListItemText
            primary={CX_VERSION || ''}
            style={{ marginLeft: '24px' }}
            className="smTitle"
          />
        </ListItem>
      </List>
    </div>
  );

  // User Profile Wrapper
  const userProfile = (
    <div className="profile-container">
      <div className="profile-avatar">
        {!!user?.avatar ? (
          <img src={user?.avatar} alt="" className="avatar" />
        ) : !user?.avatar && !!loggedInUserProfile?.avatar ? (
          <img src={loggedInUserProfile?.avatar} alt="" className="avatar" />
        ) : (
          <Avatar alt="avatar" className="avatar" />
        )}
      </div>
      <List className="profile-list" disablePadding>
        <ListItem>
          <ListItemText
            primary={
              <span className="xsTitle text-noflow">
                {`${user?.name || loggedInUserProfile?.name}
                (${user?.userName || loggedInUserProfile?.userName})`}
              </span>
            }
            secondary={
              <span className="desc">
                {user?.email || loggedInUserProfile?.email}
              </span>
            }
          />
          {isHomeMenu || isHomeGroup ? (
            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="arrow">
                <KeyboardArrowRight onClick={handleRedirectProfile} />
              </IconButton>
            </ListItemSecondaryAction>
          ) : (
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                aria-label="simple-menu"
                onClick={handleProfileClick}
              >
                <ExpandMore />
              </IconButton>
            </ListItemSecondaryAction>
          )}
        </ListItem>
      </List>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className="drawer-submenu"
      >
        <MenuItem className="drawer-dropdown" onClick={handleRedirectProfile}>
          <img className="icon-dropdown-svg" src={Profile} alt="" />
          Profile
        </MenuItem>
        <MenuItem
          className="drawer-dropdown"
          onClick={() => {
            signOut(user?.ID || loggedInUserProfile?.ID);
            // sessionStorage.clear();
            // sessionStorage.removeItem('accessToken');
          }}
        >
          <img className="icon-dropdown-svg" src={Logout} alt="" />
          Logout
        </MenuItem>
      </Menu>
    </div>
  );

  // Better open performance on mobile.
  // ModalPropers={{ keepMounted: true }}
  return (
    <>
      {loading && <Loading />}
      {drawerLoading && <Loading />}
      {updateModuleLoading && <Loading />}
      <nav className={classes.drawer} aria-label="main menu">
        <Drawer
          {...rest}
          container={container}
          variant={variant}
          anchor={'left'}
          open={open}
          onClose={onCloseDrawer}
          className="drawer"
          classes={{ paper: classes.drawerPaper }}
          ModalProps={{ keepMounted: true }}
        >
          {userProfile}
          {drawer}
        </Drawer>
      </nav>
    </>
  );
}

// order of this is important
const mode = [
  'contract',
  'client-account',
  'project-costing',
  'profit-recognition',
  'system-admin',
  'gl-interface',
  'client-contract',
  'pob-client-contract',
  'plant-machinery',
  'subcon-tender',
  'subcontract',
  'subcontractor',
  'supplier',
  'access-security',
  'common-settings',
  'system-settings',
  'company-setup',
  'fuel-consumption',
];

export const isIn = (route: string, module: string) => {
  return route.match(module);
};

export const reconsRoute = (route: string) => {
  let genRoute = mode.filter(x => isIn(route, x));
  return genRoute.length > 0 ? genRoute[genRoute.length - 1] : null;
};
